import { baseFilter, filterBy, filterValue } from './filter';

export const filter = <T>(source: T[]) => ({
  include: (values: T[]) => filter(filterValue(values)(source)),
  exclude: (values: T[]) => filter(filterValue(values, 'exclude')(source)),

  includeBy: <K extends keyof T>(key: K, values: T[K][]) => filter(filterBy(values, key)(source)),
  excludeBy: <K extends keyof T>(key: K, values: T[K][]) =>
    filter(filterBy(values, key, 'exclude')(source)),

  includeWhere: (predicate: (item: T) => boolean) => filter(baseFilter(predicate)(source)),
  excludeWhere: (predicate: (item: T) => boolean) =>
    filter(baseFilter(predicate, 'exclude')(source)),

  value: () => source,
});

// Checks whether an unknown value exists in a typed array, narrowing its type to the array's element type when found
export const isOneOf = <const T>(
  array: readonly T[],
  value: unknown,
  predicate: (item: T, value: unknown) => boolean = (item, val) => item === val,
): value is T => array.some((item) => predicate(item, value));
